import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link, RouteComponentProps } from 'react-router-dom';
import { enterFullScreen, exitFullScreen } from 'actions/screen';
import { IAppState } from 'types/app';

import MediaLgUp from '../Responsive/MediaLgUp';

import * as UserActionCreators from '../../actions/user';

import AuthenticatedHeader from './AuthenticatedHeader';
import UnauthenticatedHeader from './UnauthenticatedHeader';

class Header extends Component<Props, {}> {
  /**
   * Handle Logout
   * @return {undefined}
   */
  handleLogout = () => {
    const { dispatch } = this.props;
    dispatch(UserActionCreators.logoutUser());
  };

  toggleFullScreen = () => {
    const { dispatch, screen } = this.props;
    if (screen.full) {
      return dispatch(exitFullScreen());
    }
    return dispatch(enterFullScreen());
  };

  renderNavContent = () => {
    const { loggedIn } = this.props;
    if (loggedIn) {
      return (
        <AuthenticatedHeader
          onLogout={this.handleLogout}
          onToggleFullScreen={this.toggleFullScreen}
        />
      );
    }
    return <UnauthenticatedHeader />;
  };

  /**
   * Render
   * @return {Object}
   */
  render() {
    return (
      <MediaLgUp>
        <div className="top-stripe" role="banner">
          <div className="top-stripe__inner-container">
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-end',
              }}
            >
              <Link to="/">
                <div className="top-stripe__site-title">
                  <span className="u-visually-hidden">Fallen London</span>
                </div>
              </Link>
              {/*
              <a
                href="https://advent.fallenlondon.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  position: 'relative',
                  bottom: '7px',
                }}
              >
                Advent!
              </a>
              */}
            </div>
            <nav className="top-stripe__user">
              {this.renderNavContent()}
            </nav>
          </div>
        </div>
      </MediaLgUp>
    );
  }
}

type Props = RouteComponentProps & ReturnType<typeof mapStateToProps> & {
  dispatch: Function,
};

const mapStateToProps = (state: IAppState) => (
  {
    loggedIn: state.user.loggedIn,
    screen: state.screen,
    user: state.user.user,
  }
);

export default withRouter(connect(mapStateToProps)(Header));
